import { render, staticRenderFns } from "./BaseCrossPlatformDropdown.vue?vue&type=template&id=50ada66a&scoped=true&"
import script from "./BaseCrossPlatformDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseCrossPlatformDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseCrossPlatformDropdown.vue?vue&type=style&index=0&id=50ada66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ada66a",
  null
  
)

export default component.exports